import React, { Component } from 'react'
import * as MabnaButton from '../common/Button/Button'
import { browserHistory } from 'react-router'

export default class ResetPasswordContainer extends Component {
  render() {
    return (
      <div id="choose-reset-pass-method">
        <div
          className="text-center bg-darkblue fg-white"
          style={{ flex: 1, marginBottom: 10 }}
        >
          <h4 style={{ margin: 0, padding: 10 }}>
            لطفا روش تغییر گذرواژه را انتخاب کنید
          </h4>
        </div>

        <section style={{ alignSelf: 'center', margin: 20 }}>
          <MabnaButton.Primary
            onClick={() => browserHistory.push('/signup/reset-password/by-email')}
          >
            به وسیله ایمیل
          </MabnaButton.Primary>
          <MabnaButton.Primary
            onClick={() => browserHistory.push('/signup/reset-password/by-sms')}
          >
            به وسیله پیامک
          </MabnaButton.Primary>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/authentication/ResetPasswordContainer.js